<template>
<div>
  <Loading :isLoading="isLoading" />
  <div>
    <p style="padding:10px 10px 0px 10px;font-size:20px;color:#810042;font-weight:700;font-family:Lato;">Solicitudes Aceptadas</p>
  </div>
  <div class="py-2">
    <TableComponent :key="render" :columns="columns" :rows="rows" v-on:rowsSelected="changeRowsSelected($event)" :rangeInput="true" :exportInput="true" :checkInput="{text: `<svg xmlns='http://www.w3.org/2000/svg' class='h-5 w-5 my-auto mr-3 ' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'><path stroke-linecap='round' stroke-linejoin='round' d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' /></svg>Enviar correo`, show: true}" />    
  </div>
</div>
</template>

<script>
import { onMounted, getCurrentInstance, ref } from 'vue';
import Header from '@/components/Supervisor/Header.vue';
import MenuLateral from '@/components/Supervisor/MenuLateral.vue';
import Loading from '@/components/Loading/VueLoading.vue';
import {getTokenDecoden} from "@/helpers/tokenauth";
import TableComponent from "@/components/Forms/Tables/TableComponent";
import { useRouter } from 'vue-router';
import Affiliated from '@/classes/Affiliated.js';
import Admission from '@/classes/AdmissionRequest.js';
import Swal from 'sweetalert2';
import AdmissionRequest from '@/classes/AdmissionRequest';
import DatetimeValidator from '@/classes/DatetimeValidator';

export default {
  
  name: 'SolicitudesAceptadas',
  setup() {
    const urlWeb =  ref(process.env.VUE_APP_URLWEB);
    const urlCartaBienvenida =  ref(process.env.VUE_APP_CARTA_BIENVENIDA);
    const isLoading =  ref(false);
    const apiToken =  ref("");
    const personId =  ref("");
    const requests =  ref([]);
    const allRequests =  ref([]);
    const requestsCount =  ref(0);
    const associates =  ref([]);
    const list_email =  ref([]);
    const userId =  ref(0);
    const name =  ref("");
    const paternal_name =  ref("");
    const router = useRouter();
    const affiliatedObject = ref(null);
    const admissionObject = ref(null);
    let app = getCurrentInstance();
    let render = ref(false);
    let columns = ref([]);
    let rows = ref([]);
    const listHistoryEmails =  ref([]);
    const admissionRequestObject = ref(new AdmissionRequest());
    const datetimeValidatorObjectClass = ref(new DatetimeValidator());

    onMounted(async ()=>{
      isLoading.value = true;
      app = app.appContext.config.globalProperties;
      affiliatedObject.value = new Affiliated();
      admissionObject.value = new Admission();

      loadInfo();
      await getAssociates();
      await getRequests();
      await getHistoryEmailsBySubject();
    });

    const changeRowsSelected = (value) => {
      let rowsAdmission = value.map( node => node);
      sendEmail(rowsAdmission);
    }

    const getColumns = () => {
      columns.value = [
        { headerName: "RFC", field: "rfc", headerCheckboxSelection: true, minWidth: 200, resizable: true, sortable: true, filter: true, checkboxSelection: true,},
        { headerName: "Nombre", field: "name" },
        { headerName: "Telefono", field: "phone" },
        { headerName: "Correo", field: "email" },
        { headerName: "Monto a ahorrar", field: "savingAmount" },
        { headerName: "Puesto/Ocupación", field: "occupation" },
        { headerName: "Fecha de registro", field: "date" },
        { headerName: "Fecha de pago", field: "date_enroll_payment_fee" },
        { headerName: "Metodo de pago", field: "method_enroll_payment_fee" },
        { headerName: "Usuario asignado", field: "asigned_name" },
        { headerName: "Organización", field: "organization" },
        { headerName: "Fecha envio carta bienvenida", field: "", filter: false, cellRenderer: params => {
          if(listHistoryEmails.value.filter(ress => ress.table_id == params.data.id).length > 0){
            return datetimeValidatorObjectClass.value.normalizeDateFormat(listHistoryEmails.value.filter(ress => ress.table_id == params.data.id)[0].created_at)
          }
          return ""
        }},
        { headerName: "Solicitud", field: "doc_admission_request_signed", filter: false, cellRenderer: params => {
           if(params.data.organization.includes("sinaptissste")){
            return ""
          }else{
            if(params.value){
              const button = document.createElement("label");
              button.innerText = "Descargar documento.";
              button.className += "border-2 border-cherryColor bg-cherryColor text-white focus:bg-blue-700 px-10 py-1.5 mx-auto rounded-md cursor-pointer text-base";
              button.addEventListener("click", e => {
                e.preventDefault();
                searchDocumentSaving(params.value);
              });
              return button;
            }
            else{
              const button = document.createElement("label");
              button.innerText = "Reenviar documento.";
              button.className += "border border-cherryColor bg-white hover:bg-cherryColor text-cherryColor hover:text-white focus:bg-blue-700	px-10 py-0.5 mx-auto rounded-md cursor-pointer";
              button.addEventListener("click", e => {
                e.preventDefault();
                sendMailResendDocumentCincel(params.data)
                // e.preventDefault();
                // searchDocumentSaving(params.value);
              });
              return button;
            }
          }
        }},
        { headerName: "Ver información", field: "action", filter: false, cellRenderer: params => {
          const route = {
            path: "/supervisor/cuenta/revision-solicitudes-ingreso/"+params.value
          };

          const link = document.createElement("a");
          link.href = router.resolve(route).href;
          link.innerText = "Ver";
          link.className += "bg-cherryColor text-white focus:bg-blue-700 px-10 py-1.5 mx-auto rounded-md cursor-pointer text-base";
          link.addEventListener("click", e => {
            e.preventDefault();
            router.push(route);
          });
          return link;
        }},
        
      ];
    }

    const getAsignedUser = (value) => {
      var asociate = associates.value.filter((associate) => associate.id == value)
      if(asociate.length > 0){
        return `${asociate[0].name.toUpperCase()} ${asociate[0].paternal_name.toUpperCase()}`;
      }
      return '';
    }

    const sendEmail = (rowsAdmission) => {
      var swal = require('sweetalert2')

      swal.fire({
        title: "Aviso",
        text: `¿Desea enviar el correo de bienvenida a los usuarios seleccionados?`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO",
        confirmButtonColor: '#FEB72B',
        cancelButtonColor: '#FEB72B',
      })
      .then((result) => {
        if (result.value) {
          if (rowsAdmission.length > 0) {
            let emails = rowsAdmission.map((admission)=> admission.email)
            isLoading.value = true;
            let html = getHtmlBody();
            let bodyEncrypted = encryptBody(html);
            let attachmentList = [
              {
                file: urlCartaBienvenida.value,
                name: "carta_bienvenida.pdf"
              }
            ];

            admissionObject.value.sendMail("foncabsa", "bienvenida foncabsa", "Bienvenida", bodyEncrypted, emails, attachmentList).then(response=>{
              console.log("Response", response);
              isLoading.value = false;

              rowsAdmission.forEach((admission) => {
                registerHistoryMissingDocument(admission.email, admission.id, getHtmlBody());
              });
              getHistoryEmailsBySubject();
              getRequests();

              swal.fire({ 
                title: "Aviso",
                text: "El correo se envío correctamente",
                icon: "success",
                confirmButtonColor: '#FEB72B',
              });
            }).catch(err => {
              console.log("Error", err);
              isLoading.value = false;
              swal.fire({
                title: "Aviso",
                text: "Error al enviar el correo",
                icon: "error",
                confirmButtonColor: '#FEB72B',
              });
            });
            
          } else {
            swal.fire({
              title: "Aviso",
              text: "Favor de seleccionar una o varias solicitudes para enviar el correo de bienvenida",
              icon: "warning",
              confirmButtonColor: '#FEB72B',
            });
          }
        }
      });
    }

    function registerHistoryMissingDocument(email, admission_id, body){
      var send_to= [email]; 
      var token_auth = sessionStorage.getItem('login')
      var process = "missing_documents"
      var copy_to=[];
      var sender = "clientes@foncabsa.com"
      var subject = "Bienvenido a FONCABSA"
      var table_id = admission_id
      var table_type= "admission_requests";

      var content = {
        html: body
      };

      body = JSON.stringify(content);
      var params = {
        token_auth,
        process,
        sender,
        send_to,
        copy_to,
        subject,
        body,
        table_id,
        table_type
      };

      admissionRequestObject.value.registerHistoryMissingDocuments(params).then(response => {
        //this.getHistoryMissingDocuments();
      }).catch(error => {
        console.log('error', error);
      });
    }
    
    const encryptBody = (html) => {
      const header = { "alg": "HS256", "typ": "JWT" }
      const encodedHeader = Buffer.from(JSON.stringify(header)).toString('base64')

      var data = {
          "html": html
      }

      const encodedPayload = Buffer.from(JSON.stringify(data)).toString('base64')
      var jwtSecret = process.env.VUE_APP_JWT_SECRET;
      const crypto = require('crypto')
      const signature = crypto.createHmac('sha256', jwtSecret).update(encodedHeader + '.' + encodedPayload).digest('base64')      
      return encodedHeader+"."+encodedPayload+"."+signature
    }
    
    const getHtmlBody = () => {
      let html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet"><title>Bienvenida</title><style>@media only screen and (max-width: 769px){.div_centrado{height:830px !important}}@media only screen and (max-width: 669px){.div_centrado{height:860px !important}}@media only screen and (max-width: 649px){.div_centrado{height:900px !important}}@media only screen and (max-width: 594px){.div_centrado{height:930px !important}}@media only screen and (max-width: 589px){.div_centrado{height:950px !important}}@media only screen and (max-width: 551px){.div_centrado{height:960px !important}}@media only screen and (max-width: 522px){.div_centrado{height:990px !important}}@media only screen and (max-width: 500px){.div_centrado{height:1010px !important}}</style></head><body><div style="background:#810042;height: 130px;display: flex;width: 100%;"><div class="div_centrado" style="margin:0 auto;background:white;width:77%;height:800px;margin-top:50px;border-radius:14px; text-align: center;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);"><p style="margin-top:40px;font-family:Roboto,Arial;font-size:22px;color:#6E6E6E;font-weight:500;padding-left: 60px;padding-right: 60px;"> ¡Bienvenido a FONCABSA!</p><div><p style="font-family:Roboto,Arial;font-size:15px;font-weight:300;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;"> Toda historia empieza cuando tomamos una gran decisi&oacute;n, y atreverte a cumplir tus metas, ¡es lo que has decidido comenzar el día de hoy!</p></div><div><p style="font-family:Roboto,Arial;font-size:15px;font-weight:300;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;"> Con solidaridad, igualdad y cooperativismo combinado con responsabilidad y transparencia para crear algo que le pertenece a todos los que conformamos FONCABSA SOCAP.</p></div><div><p style="font-family:Roboto,Arial;font-weight:700;font-size:15px;color:#000;padding-left: 60px;padding-right: 60px;text-align: center;"> Conoce los beneficios de ser parte de FONCABSA</p></div><div style="display:flex;padding-left: 60px;padding-right: 60px;"><div style="margin: 0 auto;"> <img src="https://cabsacloud.ams3.digitaloceanspaces.com/store/FONCABSA/assets/hand_icon.png" alt=""><p style="font-family:Roboto,Arial;font-weight:300;font-size:15px;color:#000;padding-left: 10px;padding-right: 10px;text-align: center;">Las tasas de inter&eacute;s m&aacute;s bajas.</p></div><div style="margin: 0 auto;"> <img src="https://cabsacloud.ams3.digitaloceanspaces.com/store/FONCABSA/assets/saving_icon.png" alt=""><p style="font-family:Roboto,Arial;font-weight:300;font-size:15px;color:#000;padding-left: 10px;padding-right: 10px;text-align: center;">Mayor facilidad para ahorrar.</p></div><div style="margin: 0 auto;"> <img src="https://cabsacloud.ams3.digitaloceanspaces.com/store/FONCABSA/assets/shield_icon.png" alt=""><p style="font-family:Roboto,Arial;font-weight:300;font-size:15px;color:#000;padding-left: 10px;padding-right: 10px;text-align: center;">Protecci&oacute;n y buena rentabilidad <br/> para financiar tus metas.</p></div></div><p style="margin-top:20px;"> <a href="${urlWeb.value}/login"> <input type="button" value="Accede a tu cuenta" style="text-decoration:none; font-family:Roboto, Arial; font-size: 13px; opacity: 0.8; color:#FFFFFF; padding-top:7px; padding-bottom:7px; padding-left:35px; padding-right:35px; background-color:#FEB72B; border: 0px solid; border-width: 3px;border-radius:35px; cursor: pointer;" /> </a></p><p style="margin-top: 30px;font-family:Roboto,Arial;font-weight:300;font-size:13px;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;"> Para cualquier pregunta puede enviar un mensaje al correo clientes@foncabsa.com, estaremos dispuestos a ayudarle.</p><p style="font-family:Roboto,Arial;font-weight:300;font-size:13px;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;"> Saludos. <br> El equipo de FONCABSA.</p><div style="display: flex;padding-left: 60px;padding-right: 60px;margin-top: 10px;"><hr style="width: 100%;border: 1px solid #810042;"></div><p style="font-family:Roboto,Arial;font-weight:300;font-size:13px;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: center;margin-top:10px;"> FONCABSA le ha enviado este mensaje <br> <a href="https://foncabsa.com/" style="text-decoration:none;">FONCABSA</a></p></div></div><div style="background:#fcfcfc;height: 570px;display: flex;margin:0 auto; width: 50%;margin:0 auto;"></div></body></html>`
      return html;
    }

    const getRequests = async() =>{
      return await getAcceptedRequests().then((response) => {
      });
    }

    const getHistoryEmailsBySubject = async() =>{
      return await admissionObject.value.getHistoryEmailsBySubject(sessionStorage.getItem('login'), "admission_requests", "Bienvenido a FONCABSA", "missing_documents").then(resp=>{
        listHistoryEmails.value = resp.data.response.data
      })
    }

    const loadInfo = () => {
      var auth = getTokenDecoden();
      apiToken.value =  sessionStorage.getItem("login");
      personId.value = auth.obj.personnel_info['id'];
      userId.value = auth['id'];
      name.value = auth.obj['personnel_info']['name'];
      paternal_name.value = auth.obj['personnel_info']['paternal_name'];
    }

    const getAssociates = async () => {
      affiliatedObject.value.getAllAnalysts(apiToken.value).then(response => {
        associates.value = response.data.response.analysts;
        isLoading.value = false;
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
        swal.fire({
          title: "Aviso",
          text: "Ocurrió un error al obtener los asociados",
          icon: "error",
          confirmButtonColor: '#FEB72B',
        });
      });
    }

    const convertListToArray = (list) => {
      let index = [];
      let array = [];
      for (var i in list) {
        index.push(i);
      }

      for (let i = 0; i < index.length; i++) {
        array.push(list[index[i]]);
      }

      return array;
    }

    const getFinalArrayList = (array) => {
      let finalArray = [];
      try {
        for (let i = 0; i < array.length; i++) {
          let contact_info = convertListToArray(array[i].admission_information.contact_info_attributes);

          var id = array[i].id;
          var rfc = array[i].admission_information.rfc;
          var name = app.$filters.formatCamelize(`${array[i].admission_information.name} ${array[i].admission_information.middle_name} ${array[i].admission_information.paternal_name} ${array[i].admission_information.maternal_name}`);
          var completeName = app.$filters.formatCamelize(`${array[i].admission_information.name} ${array[i].admission_information.paternal_name}`);
          var phone = app.$filters.formatPhone(contact_info.filter(({contact_type}) => contact_type === 'celular').length > 0 ? contact_info.filter(({contact_type}) => contact_type === 'celular')[0].value : "1111111111");
          var email = contact_info.filter(({contact_type}) => contact_type === 'correo').length > 0 ? contact_info.filter(({contact_type}) => contact_type === 'correo')[0].value : "correo@gmail.com";
          var savingAmount = app.$filters.formatCurrency(array[i].admission_information.saving_registration_attributes.amount == "" ? "0" : array[i].admission_information.saving_registration_attributes.amount);
          
          var occupation = array[i].admission_information.work_info_attributes.occupation;
          var laboralStatus = array[i].admission_information.work_info_attributes.laboral_status;
          occupation = app.$filters.formatCamelize(laboralStatus.toLowerCase() == "jubilado" ? "jubilado" : occupation);

          var date = app.$filters.formatDate(array[i].created_at);
          var status = array[i].status;
          var date_enroll_payment_fee = app.$filters.formatDate(array[i].admission_information.enrollment_fee_payment_date);
          var method_enroll_payment_fee = array[i].admission_information.enrollment_fee_method;
          var asigned_name = array[i].status == "aceptada" ? getAsignedUser(array[i].admission_analyst_id) : "";
          var organization = array[i].person.user.organization_list.join();

          finalArray.push({
            id: id,
            rfc: rfc,
            name: name,
            completeName: completeName,
            phone: phone,
            email: email,
            savingAmount: savingAmount,
            occupation: occupation,
            date : date,
            status: status,
            date_enroll_payment_fee: date_enroll_payment_fee,
            method_enroll_payment_fee: method_enroll_payment_fee,
            asigned_name: asigned_name,
            organization: organization,
            action: id,
            view: id
          })
        }
      } catch (error) {
        console.log(error)
      }
      return finalArray;
    }

    const getAcceptedRequests = async() => {
      isLoading.value = true;
      render.value = false;
      await affiliatedObject.value.getNewRequests(apiToken.value, "aceptada").then(response => {
        let finalArray = (response.data.response.admission_request != undefined)? getFinalArrayList(response.data.response.admission_request): [];
        requests.value = finalArray.reverse();
        allRequests.value = finalArray.reverse();

        requestsCount.value = requests.value.length;
        getColumns();
        rows.value = requests.value.reverse();
        render.value = true;
        isLoading.value = false;
      }).catch(err => {
        console.log("Error", err);
        requests.value = [];
        requestsCount.value = 0;
        render.value = false;
        isLoading.value = false;
      });
    }

    const searchDocumentSaving = async(id_admission_request) => {
      var swal = require('sweetalert2')
      isLoading.value = true;
      affiliatedObject.value.getDocumentCincel(apiToken.value, "admission_requests", id_admission_request, "AHORRO", "documentos_alta_socios").then(response => {
        isLoading.value = false;
        window.open(response.data.response.path,'_blank');
      }).catch(err => {
        console.log("Error", err);
        isLoading.value = false;
        swal.fire({
          title: "Aviso",
          text: "Documento no se encuentra firmado",
          icon: "info",
          confirmButtonColor: '#FEB72B',
        });
      });
    }

    async function sendMailResendDocumentCincel(params){
     try {
      isLoading.value = true;
      const _response =await admissionObject.value.sendMailResendDocumentCincel({
        token_auth:sessionStorage.getItem('login'),
        admission_request_id:params.id,
        "abbreviation":"AHORRO"
      });

      if(_response.status==200){
        Swal.fire({
          icon:"success",
          title:"El correo fue enviado.",
          text:"Sea realizo el envió al correo la firma del documento."
        });
        isLoading.value = false;
      }
      if(_response.status!=200){      
        let messages="";
        if(_response.data.errors != null)
        {
          _response.data.errors.forEach(element => {
            messages+="<strong>■ "+element+".</strong><br>";
          });
        }
        if( _response.data.response.message != null){
          messages+="<strong>■ "+_response.data.response.message+".</strong><br>";
        }
        Swal.fire({
          title: "Aviso",
          html:messages,
          icon: "info",
          confirmButtonText: "OK",
          confirmButtonColor: '#FEB72B'
        });
        isLoading.value = false;
      }
     } catch(error){
        isLoading.value = false;
      console.log("Eror inesperado :: ",error)
      Swal.fire({
          title: "Ocurrio un error inesperado",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: '#FEB72B'
        });
     }
    }

    return {
      isLoading,
      render,
      columns,
      rows,
      changeRowsSelected
    }
  },
  components: {
    Header,
    Loading,
    MenuLateral,
    TableComponent
  }
}
</script>
